module.exports = __webpack_public_path__ + "static/img/icon_gexinghua_zhenliao_jiece.42aa552d.png";